import type {
  DivElementType as ModalContentDivElementType,
  ContentProps as ModalContentProps,
} from "./Content";
import { Content } from "./Content";
import type {
  HeaderElementType as ModalHeaderElementType,
  HeaderProps as ModalHeaderProps,
} from "./Header";
import { Header } from "./Header";
import { Modal as ModalComponent } from "./Modal";
import type { ModalProps, ModalContextProps } from "./types";
import { useModal } from "./useModal";

const Modal = Object.assign(ModalComponent, {
  Header,
  Content,
});

Modal.displayName = "Modal";
export { Modal, useModal };

export type {
  ModalContextProps,
  ModalContentDivElementType,
  ModalContentProps,
  ModalHeaderElementType,
  ModalHeaderProps,
  ModalProps,
};
